import ReadeablePdfStream from './ReadablePdfStream';

export class RawPdfDocument extends ReadeablePdfStream {
  constructor(bytes: Uint8Array) {
    super(bytes);
  }
}
